// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UnbxdTextSearch-module__wrapper","iconBtn":"UnbxdTextSearch-module__iconBtn"};